import { render, staticRenderFns } from "./RootTabs.vue?vue&type=template&id=2fdacd26&scoped=true"
import script from "./RootTabs.vue?vue&type=script&lang=ts"
export * from "./RootTabs.vue?vue&type=script&lang=ts"
import style0 from "./RootTabs.vue?vue&type=style&index=0&id=2fdacd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdacd26",
  null
  
)

export default component.exports